export enum AuthStatus {
  UNKNOWN = "UNKNOWN",
  REGISTERED = "REGISTERED",
  BLOCKED = "BLOCKED",
  WAIT_INITIATE = "WAIT_INITIATE",
  WAIT_PIN = "WAIT_PIN",
  ACTIVE = "ACTIVE",
  ON_PREMISE = "ON_PREMISE",
  ON_PREMISE_ACTIVE = "ON_PREMISE_ACTIVE",
  ON_SAAS_ACTIVE = "ON_SAAS_ACTIVE",
  UNDEFINED_TYPE = "UNDEFINED_TYPE",
  EXPIRED = "EXPIRED",
  READONLY = "READ_ONLY",
}

export interface StateResponse {
  username: string;
  state: AuthStatus;
}
